import { render, staticRenderFns } from "./base_print.vue?vue&type=template&id=604839d1&scoped=true&"
import script from "./base_print.vue?vue&type=script&lang=js&"
export * from "./base_print.vue?vue&type=script&lang=js&"
import style0 from "./base_print.vue?vue&type=style&index=0&id=604839d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604839d1",
  null
  
)

export default component.exports